import { render, staticRenderFns } from "./elec-ratio-pie.vue?vue&type=template&id=687a465b&scoped=true&"
import script from "./elec-ratio-pie.vue?vue&type=script&lang=js&"
export * from "./elec-ratio-pie.vue?vue&type=script&lang=js&"
import style0 from "./elec-ratio-pie.vue?vue&type=style&index=0&id=687a465b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a465b",
  null
  
)

export default component.exports